import { motion } from 'framer-motion';
import React from 'react';
import { Route, withRouter } from "react-router-dom";
import { pageTransitions, transitionDuration } from '../../../../../Util/PageTransitions';
import Tab from "../../../../../Util/Tabs/Tab.js";
import List from './list/list';
import "./Classifieds.css";

function Classifieds(props) {

    const tabs = [
        {
            name: 'Pending',
            url: ''
        },
        {
            name: 'Approved',
            url: '/approved'
        },
        {
            name: 'Expired',
            url: '/expired'
        }
    ];
    return <>
        <motion.div className='outer-wrapper' initial={pageTransitions.initial} animate={pageTransitions.in} exit={pageTransitions.out} transition={{ duration: transitionDuration }}>
            <div className="content-wrapper users-wrapper classifieds-wrapper">
                <div className="heading-wrapper">
                    <h1 className="heading">Classifieds</h1>
                </div>
                <Tab tabs={tabs} />
                <Route path={`${props.match.path}`} exact>
                    <List status="pending"></List>
                </Route>
                <Route path={`${props.match.path}/approved`}>
                    <List status="approved"></List>
                </Route>
                <Route path={`${props.match.path}/expired`}>
                    <List status="expired"></List>
                </Route>
            </div>
        </motion.div>
    </>
}

export default withRouter(Classifieds);